export const PLACEHOLDER_TEXT_ID = 'editor.content.placeholder.11';

export const ANALYTICS_SOURCE = 'next-FullPageEditorComponent';

export const EASY_MENTIONS_PLACEHOLDER_TEXT_ID = 'editor.content.placeholder.easy.mentions';

//  Placeholder text when AI is not enabled and Blank Page Quick Actions are not enabled
export const EASY_MENTIONS_PLACEHOLDER_DEFAULT_MESSAGE =
	'Type / for all elements or @ to mention someone.';

export const AI_PLACEHOLDER_TEXT_ID = 'editor.content.placeholder.ai';

//  Placeholder text when AI is enabled
export const AI_PLACEHOLDER_DEFAULT_MESSAGE =
	"Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we'll let them know).";
